import { IMAGE_DESKTOP, IMAGE_MOBILE, ICON_FIELD } from '../elements/assets'

export const CTA_ADVANCED = `
...on ctaAdvanced_Entry {
  id
  typeHandle

  ctaAdvancedContent {
    ... on ctaAdvancedContent_Entry {
     id
     heading {
        html
      }
      description
      subheading
      headingBottom {
        html
      }
      ${ IMAGE_DESKTOP }
      ${ IMAGE_MOBILE }
      descriptionBottom
      ${ ICON_FIELD }
      demoLink {
        url
        title
      }
      
    }
  }
}
`